import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("UI error:", error, info);
  }
  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div className="min-h-[60vh] grid place-items-center p-8">
          <div className="card p-8 max-w-md text-center">
            <div className="overline">Erreur d'affichage</div>
            <h2 className="font-display text-2xl font-bold mt-2">Quelque chose s'est mal passé</h2>
            <p className="text-sm text-slate-600 mt-2">L'interface a rencontré un problème. Essayez de recharger la page.</p>
            <button onClick={() => window.location.reload()} className="btn-primary mt-5">Recharger</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
